import { Controller } from "@hotwired/stimulus";

// Default brand presets
const BASE = {
  loginTitle: "Sign in",
  loginSubtitle: "Sign in to view your classes and manage your training",
  forgotPassword: "Forgot your password? Contact the front desk.",
  enableCommunity: true,
  enableInbox: true,
  enableEvents: true,
  allowSelfSignup: false,
  allowPublicSchedule: false,
  successColor: "22C55E",
  warningColor: "F59E0B",
  dangerColor: "EF4444",
};

const PRESETS = {
  basic: {
    ...BASE,
    appName: "Your Gym",
    displayName: "Your Gym",
    primaryColor: "111111",
    tintColor: "111111",
    secondaryColor: "333333",
    accentColor: "E53E3E",
    textColor: "111111",
    textMutedColor: "666666",
    backgroundColor: "F5F5F5",
    surfaceColor: "FFFFFF",
    borderColor: "E0E0E0",
    supportEmail: "info@yourgym.com",
  },
  midnight: {
    ...BASE,
    appName: "Your Gym",
    displayName: "Your Gym",
    primaryColor: "6366F1",
    tintColor: "6366F1",
    secondaryColor: "818CF8",
    accentColor: "F59E0B",
    textColor: "F1F5F9",
    textMutedColor: "94A3B8",
    backgroundColor: "0F172A",
    surfaceColor: "1E293B",
    borderColor: "334155",
    supportEmail: "info@yourgym.com",
  },
  ember: {
    ...BASE,
    appName: "Your Gym",
    displayName: "Your Gym",
    primaryColor: "EA580C",
    tintColor: "EA580C",
    secondaryColor: "F97316",
    accentColor: "FBBF24",
    textColor: "FEF2F2",
    textMutedColor: "A8A29E",
    backgroundColor: "1C1917",
    surfaceColor: "292524",
    borderColor: "44403C",
    supportEmail: "info@yourgym.com",
  },
  stealth: {
    ...BASE,
    appName: "Your Gym",
    displayName: "Your Gym",
    primaryColor: "22C55E",
    tintColor: "22C55E",
    secondaryColor: "4ADE80",
    accentColor: "A3E635",
    textColor: "E2E8F0",
    textMutedColor: "94A3B8",
    backgroundColor: "111827",
    surfaceColor: "1F2937",
    borderColor: "374151",
    supportEmail: "info@yourgym.com",
  },
  ocean: {
    ...BASE,
    appName: "Your Gym",
    displayName: "Your Gym",
    primaryColor: "0369A1",
    tintColor: "0369A1",
    secondaryColor: "0EA5E9",
    accentColor: "F97316",
    textColor: "0C4A6E",
    textMutedColor: "64748B",
    backgroundColor: "F0F9FF",
    surfaceColor: "FFFFFF",
    borderColor: "BAE6FD",
    supportEmail: "info@yourgym.com",
  },
  forest: {
    ...BASE,
    appName: "Your Gym",
    displayName: "Your Gym",
    primaryColor: "2D6A4F",
    tintColor: "2D6A4F",
    secondaryColor: "40916C",
    accentColor: "D4A373",
    textColor: "1B4332",
    textMutedColor: "6B7F75",
    backgroundColor: "F0F4F1",
    surfaceColor: "FFFFFF",
    borderColor: "D8E2DC",
    supportEmail: "info@yourgym.com",
  },
  crimson: {
    ...BASE,
    appName: "Your Gym",
    displayName: "Your Gym",
    primaryColor: "991B1B",
    tintColor: "991B1B",
    secondaryColor: "B91C1C",
    accentColor: "F59E0B",
    textColor: "1C1917",
    textMutedColor: "78716C",
    backgroundColor: "FAF9F6",
    surfaceColor: "FFFFFF",
    borderColor: "E7E5E4",
    supportEmail: "info@yourgym.com",
  },
  royal: {
    ...BASE,
    appName: "Your Gym",
    displayName: "Your Gym",
    primaryColor: "7C3AED",
    tintColor: "7C3AED",
    secondaryColor: "A78BFA",
    accentColor: "EC4899",
    textColor: "1E1B4B",
    textMutedColor: "6B7280",
    backgroundColor: "FAF5FF",
    surfaceColor: "FFFFFF",
    borderColor: "E9D5FF",
    supportEmail: "info@yourgym.com",
  },
  sand: {
    ...BASE,
    appName: "Your Gym",
    displayName: "Your Gym",
    primaryColor: "B45309",
    tintColor: "B45309",
    secondaryColor: "D97706",
    accentColor: "92400E",
    textColor: "451A03",
    textMutedColor: "92400E",
    backgroundColor: "FFFBEB",
    surfaceColor: "FFFFFF",
    borderColor: "FDE68A",
    supportEmail: "info@yourgym.com",
  },
  abyss: {
    ...BASE,
    appName: "Your Gym",
    displayName: "Your Gym",
    primaryColor: "DC2626",
    tintColor: "DC2626",
    secondaryColor: "EF4444",
    accentColor: "F59E0B",
    textColor: "FAFAFA",
    textMutedColor: "71717A",
    backgroundColor: "0A0A0A",
    surfaceColor: "171717",
    borderColor: "27272A",
    supportEmail: "info@yourgym.com",
  },
  neon: {
    ...BASE,
    appName: "Your Gym",
    displayName: "Your Gym",
    primaryColor: "84CC16",
    tintColor: "84CC16",
    secondaryColor: "A3E635",
    accentColor: "FACC15",
    textColor: "F5F5F5",
    textMutedColor: "A1A1AA",
    backgroundColor: "18181B",
    surfaceColor: "27272A",
    borderColor: "3F3F46",
    supportEmail: "info@yourgym.com",
  },
  arctic: {
    ...BASE,
    appName: "Your Gym",
    displayName: "Your Gym",
    primaryColor: "38BDF8",
    tintColor: "38BDF8",
    secondaryColor: "7DD3FC",
    accentColor: "2DD4BF",
    textColor: "E2E8F0",
    textMutedColor: "94A3B8",
    backgroundColor: "0F1729",
    surfaceColor: "1E293B",
    borderColor: "334155",
    supportEmail: "info@yourgym.com",
  },
};

const COLOR_FIELDS = [
  "primaryColor",
  "tintColor",
  "secondaryColor",
  "accentColor",
  "textColor",
  "textMutedColor",
  "backgroundColor",
  "surfaceColor",
  "borderColor",
  "successColor",
  "warningColor",
  "dangerColor",
];

export default class extends Controller {
  static targets = [
    "previewFrame",
    "screenTab",
    "screenPanel",
    "logoPreview",
    "logoPlaceholder",
    "presetButton",
    "mobileSheet",
    "mobileOverlay",
    "customizeButton",
    "inAppTab",
    "tabHint",
  ];

  // `logoUrl` seeds the preview from an already-uploaded account logo
  // (App Branding page). Absent on the public marketing preview, where
  // the logo only ever comes from a client-side upload.
  static values = { logoUrl: String };

  connect() {
    // Start with basic preset, then layer saved config from localStorage (if any),
    // then override with any pre-filled form values (e.g. gym name from account)
    this.config = { ...PRESETS.basic };
    this.logoDataUrl = null;
    this._autoScrollId = null;
    this._autoScrollStopped = false;

    this._loadFromLocalStorage();

    // Fall back to the account's uploaded logo when nothing was restored
    // from a client-side upload / localStorage. A plain URL works as an
    // <img src> just like the FileReader data URL does.
    if (!this.logoDataUrl && this.hasLogoUrlValue && this.logoUrlValue) {
      this.logoDataUrl = this.logoUrlValue;
    }

    // Detect initial screen from whichever panel is visible (not hidden)
    const visiblePanel = this.screenPanelTargets.find((p) => !p.classList.contains("hidden"));
    this.activeScreen = visiblePanel ? visiblePanel.dataset.screen : "classes";

    // Read any pre-filled form values into config (e.g. gym name from account)
    this._readInputsIntoConfig();
    this.syncAllInputs();
    this.syncPreview();
  }

  disconnect() {
    this._stopAutoScroll();
  }

  // ── Input handlers ──────────────────────────────────────────────────

  updateField(event) {
    const field = event.target.dataset.field;
    if (!field) return;
    const value = event.target.value;

    if (COLOR_FIELDS.includes(field)) {
      this.config[field] = value.replace(/^#/, "");
      this._syncColorPair(field);
    } else if (event.target.type === "checkbox") {
      this.config[field] = event.target.checked;
    } else {
      this.config[field] = value;
      if (field === "displayName") this.config.appName = value;
    }
    this.syncPreview();
  }

  updateColorPicker(event) {
    const field = event.target.dataset.field;
    if (!field) return;
    this.config[field] = event.target.value.replace(/^#/, "");
    this._syncColorPair(field);
    this.syncPreview();
  }

  _syncColorPair(field) {
    const hex = this.config[field];
    const textInput = this.element.querySelector(
      `input[type="text"][data-field="${field}"]`
    );
    if (textInput) textInput.value = hex;
    const colorInput = this.element.querySelector(
      `input[type="color"][data-field="${field}"]`
    );
    if (colorInput) colorInput.value = `#${hex}`;
  }

  uploadLogo(event) {
    const file = event.target.files?.[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = (e) => {
      this.logoDataUrl = e.target.result;
      this.syncPreview();
    };
    reader.readAsDataURL(file);
  }

  clearLogo() {
    this.logoDataUrl = null;
    const fileInput = this.element.querySelector('input[data-field="logo"]');
    if (fileInput) fileInput.value = "";
    this.syncPreview();
  }

  // ── Presets ─────────────────────────────────────────────────────────

  applyPreset(event) {
    const presetName = event.currentTarget.dataset.preset;
    const preset = PRESETS[presetName];
    if (!preset) return;
    this.config = { ...preset };
    // Logo persists across preset changes — don't clear it
    this.syncAllInputs();
    this.syncPreview();
    this.presetButtonTargets.forEach((btn) => {
      const isActive = btn.dataset.preset === presetName;
      btn.classList.toggle("ring-2", isActive);
      btn.classList.toggle("ring-primary-400", isActive);
    });
  }

  // ── Screen tabs ─────────────────────────────────────────────────────

  switchScreen(event) {
    this.activeScreen = event.currentTarget.dataset.screen;
    this.screenTabTargets.forEach((tab) => {
      const isActive = tab.dataset.screen === this.activeScreen;
      tab.classList.toggle("bg-gray-700", isActive);
      tab.classList.toggle("text-white", isActive);
      tab.classList.toggle("text-gray-400", !isActive);
    });
    this.screenPanelTargets.forEach((panel) => {
      panel.classList.toggle(
        "hidden",
        panel.dataset.screen !== this.activeScreen
      );
    });

    // Update in-app tab highlights via syncPreview
    this.syncPreview();

    // Fade out the tab hint on first interaction (no layout shift)
    if (this.hasTabHintTarget && !this._tabHintDismissed) {
      this._tabHintDismissed = true;
      this.tabHintTarget.style.transition = "opacity 0.3s ease";
      this.tabHintTarget.style.opacity = "0";
    }

    // Auto-scroll community feed
    this._stopAutoScroll();
    if (this.activeScreen === "community") {
      this._startAutoScroll();
    }
  }

  // Save current config to localStorage and redirect to signup
  saveAndRedirect(event) {
    event.preventDefault();
    this._saveToLocalStorage();
    const url = event.currentTarget.dataset.redirectUrl || "/signup";
    window.location.href = url;
  }

  // Save customizations without navigating. Pair with waitlist-modal#open
  // via multi-action on the same button so the user's customizations are
  // preserved when they submit their lead info in the modal.
  saveCustomizations(event) {
    this._saveToLocalStorage();
    // Don't preventDefault — allow chained actions (e.g. waitlist-modal#open)
  }

  dismissTabHint() {
    if (this.hasTabHintTarget) {
      this._tabHintDismissed = true;
      this.tabHintTarget.style.transition = "opacity 0.3s ease";
      this.tabHintTarget.style.opacity = "0";
    }
  }

  _startAutoScroll() {
    this._autoScrollStopped = false;
    const panel = this.screenPanelTargets.find(
      (p) => p.dataset.screen === "community"
    );
    if (!panel) return;

    const scrollable = panel.querySelector("[data-feature='community']");
    if (!scrollable) return;

    // Reset scroll position
    scrollable.scrollTop = 0;

    // Stop on any user interaction
    const stop = () => {
      this._autoScrollStopped = true;
      this._stopAutoScroll();
      scrollable.removeEventListener("touchstart", stop);
      scrollable.removeEventListener("mousedown", stop);
      scrollable.removeEventListener("wheel", stop);
    };
    scrollable.addEventListener("touchstart", stop, { passive: true });
    scrollable.addEventListener("mousedown", stop);
    scrollable.addEventListener("wheel", stop, { passive: true });

    // Start slow scroll after a short delay
    setTimeout(() => {
      if (this._autoScrollStopped) return;
      this._autoScrollId = setInterval(() => {
        if (this._autoScrollStopped) {
          this._stopAutoScroll();
          return;
        }
        scrollable.scrollTop += 0.5;
        // Stop at the bottom
        if (scrollable.scrollTop + scrollable.clientHeight >= scrollable.scrollHeight - 1) {
          this._stopAutoScroll();
        }
      }, 16); // ~60fps
    }, 800);
  }

  _stopAutoScroll() {
    if (this._autoScrollId) {
      clearInterval(this._autoScrollId);
      this._autoScrollId = null;
    }
  }

  // ── Mobile sheet ────────────────────────────────────────────────────

  openSheet() {
    if (!this.hasMobileSheetTarget) return;
    this.mobileSheetTarget.classList.remove("translate-y-full");
    this.mobileOverlayTarget.classList.remove("hidden");
    if (this.hasCustomizeButtonTarget) this.customizeButtonTarget.classList.add("hidden");
    document.body.style.overflow = "hidden";
  }

  closeSheet() {
    if (!this.hasMobileSheetTarget) return;
    this.mobileSheetTarget.classList.add("translate-y-full");
    this.mobileOverlayTarget.classList.add("hidden");
    if (this.hasCustomizeButtonTarget) this.customizeButtonTarget.classList.remove("hidden");
    document.body.style.overflow = "";
  }

  // ── Sync all form inputs from config ────────────────────────────────

  syncAllInputs() {
    Object.entries(this.config).forEach(([field, value]) => {
      if (COLOR_FIELDS.includes(field)) {
        const textInput = this.element.querySelector(
          `input[type="text"][data-field="${field}"]`
        );
        if (textInput) textInput.value = value;
        const colorInput = this.element.querySelector(
          `input[type="color"][data-field="${field}"]`
        );
        if (colorInput) colorInput.value = `#${value}`;
      } else if (typeof value === "boolean") {
        const checkbox = this.element.querySelector(
          `input[type="checkbox"][data-field="${field}"]`
        );
        if (checkbox) checkbox.checked = value;
      } else {
        const input = this.element.querySelector(
          `input[data-field="${field}"], textarea[data-field="${field}"]`
        );
        if (input) input.value = value;
      }
    });
  }

  // ── Preview rendering ───────────────────────────────────────────────

  syncPreview() {
    const c = this.config;
    const frame = this.previewFrameTarget;

    frame.style.setProperty("--p-primary", `#${c.primaryColor}`);
    frame.style.setProperty("--p-tint", `#${c.tintColor}`);
    frame.style.setProperty("--p-secondary", `#${c.secondaryColor}`);
    frame.style.setProperty("--p-accent", `#${c.accentColor}`);
    frame.style.setProperty("--p-text", `#${c.textColor}`);
    frame.style.setProperty("--p-muted", `#${c.textMutedColor}`);
    frame.style.setProperty("--p-bg", `#${c.backgroundColor}`);
    frame.style.setProperty("--p-surface", `#${c.surfaceColor}`);
    frame.style.setProperty("--p-border", `#${c.borderColor}`);
    frame.style.setProperty("--p-success", `#${c.successColor}`);
    frame.style.setProperty("--p-warning", `#${c.warningColor}`);
    frame.style.setProperty("--p-danger", `#${c.dangerColor}`);

    this._updatePreviewTexts();
    this._updatePreviewLogo();
    this._updateFeatureVisibility();
    this._updateInAppTabs();
  }

  _updatePreviewTexts() {
    const c = this.config;
    this._setText("[data-preview='appName']", c.displayName || c.appName);
    this._setText("[data-preview='loginTitle']", c.loginTitle);
    this._setText("[data-preview='loginSubtitle']", c.loginSubtitle);
    this._setText("[data-preview='forgotPassword']", c.forgotPassword);
    this._setText("[data-preview='supportEmail']", c.supportEmail);
  }

  _updatePreviewLogo() {
    this.logoPreviewTargets.forEach((img) => {
      if (this.logoDataUrl) {
        img.src = this.logoDataUrl;
        img.classList.remove("hidden");
      } else {
        img.classList.add("hidden");
      }
    });
    this.logoPlaceholderTargets.forEach((el) => {
      el.classList.toggle("hidden", !!this.logoDataUrl);
    });
  }

  _updateFeatureVisibility() {
    const c = this.config;
    this._toggleVisible("[data-feature='community']", c.enableCommunity);
    this._toggleVisible("[data-feature='selfSignup']", c.allowSelfSignup);
    this._toggleVisible("[data-feature='communityTab']", c.enableCommunity);
    this._toggleVisible("[data-feature='inboxTab']", c.enableInbox);
  }

  _saveToLocalStorage() {
    try {
      const data = { config: this.config, logoDataUrl: this.logoDataUrl };
      localStorage.setItem("schedulous_app_preview", JSON.stringify(data));
    } catch (e) {
      // localStorage unavailable or full — silently skip
    }
  }

  _loadFromLocalStorage() {
    try {
      const raw = localStorage.getItem("schedulous_app_preview");
      if (!raw) return;
      const data = JSON.parse(raw);
      if (data.config) {
        Object.assign(this.config, data.config);
      }
      if (data.logoDataUrl) {
        this.logoDataUrl = data.logoDataUrl;
      }
      // Clear after loading on onboarding pages (one-time transfer)
      if (window.location.pathname.startsWith("/welcome")) {
        localStorage.removeItem("schedulous_app_preview");
      }
    } catch (e) {
      // Corrupt or unavailable — start fresh
    }
  }

  _readInputsIntoConfig() {
    // Override preset defaults with any pre-filled input values
    this.element.querySelectorAll("input[data-field], textarea[data-field]").forEach((input) => {
      const field = input.dataset.field;
      if (!field || input.type === "file") return;
      if (input.type === "color") return; // color pickers mirror text inputs
      if (input.type === "checkbox") {
        this.config[field] = input.checked;
      } else if (input.value && input.value.trim()) {
        const val = input.value.trim();
        if (COLOR_FIELDS.includes(field)) {
          this.config[field] = val.replace(/^#/, "");
        } else {
          this.config[field] = val;
        }
      }
    });
    // Sync appName from displayName if set
    if (this.config.displayName) {
      this.config.appName = this.config.displayName;
    }
  }

  _updateInAppTabs() {
    if (!this.hasInAppTabTarget) return;
    this.inAppTabTargets.forEach((tab) => {
      const isActive = tab.dataset.screen === this.activeScreen;
      const icon = tab.querySelector("[data-tab-icon]");
      const label = tab.querySelector("[data-tab-label]");
      const activeColor = `var(--p-primary)`;
      const inactiveColor = `var(--p-muted)`;
      if (icon) icon.style.color = isActive ? activeColor : inactiveColor;
      if (label) {
        label.style.color = isActive ? activeColor : inactiveColor;
        label.style.fontWeight = isActive ? "600" : "400";
      }
    });
  }

  _setText(selector, text) {
    this.previewFrameTarget
      .querySelectorAll(selector)
      .forEach((el) => (el.textContent = text));
  }

  _toggleVisible(selector, visible) {
    this.previewFrameTarget
      .querySelectorAll(selector)
      .forEach((el) => el.classList.toggle("hidden", !visible));
  }
}
